export default __webpack_public_path__ + "static/media/rehab.3d1bb693.svg";